import normalBrBlack from "../assets/logo/logo-brcomerce.png"
import normalBrWhite from "../assets/logo/logo_brcomerce_branco.svg"
import normalBrFullWhite from "../assets/logo/logo-brcomerce-white.png"
import blackFridayBrBlack from "../assets/logo/logo-black-friday-black.png"
import blackFridayBrWhite from "../assets/logo/logo-black-friday-white.png"
import festaJuninaBrWhite from "../assets/logo/logo-junina.png"
import festaJuninaBrBlack from "../assets/logo/logo-back-white-junina.png"
import pascoaBrBlack from "../assets/logo/logo-pascoa.png"
import pascoaBrWhite from "../assets/logo/logo-pascoa-white.png"
import diaDosNamoradosBrBlack from "../assets/logo/logo-dia-dos-namorados-colorido.svg"
import diaDosNamoradosBrWhite from "../assets/logo/logo-dia-dos-namorados-fundo-branco.svg"
import natalBrBlack from "../assets/logo/logo-natalino.png"
import natalBrWhite from "../assets/logo/logo-natalino-white.png"
import carnavalBrWhite from "../assets/logo/LogoCarnaval_Branca.png"
import carnavalBrBlack from "../assets/logo/LogoCarnaval_Preta.png"
import diaDasMaesBrWhite from "../assets/logo/LogoDiaDasMães_Branca.png"
import diaDasMaesBrBlack from "../assets/logo/LogoDiaDasMães_Preta.png"
import diaDosPaisBrWhite from "../assets/logo/LogoDiaDosPais_Branca.png"
import diaDosPaisBrBlack from "../assets/logo/LogoDiaDosPais_Preta.png"
import reveillonBrWhite from "../assets/logo/Logo_reveillon_Branca.svg"
import reveillonBrBlack from "../assets/logo/Logo_reveillon_Preta.svg"
import copaWhite from "../assets/logo/logo-copa-branca.svg"
import copaBlack from "../assets/logo/logo-copa-preta.svg"


export const logosEnum = {
    normal: {
        black: normalBrBlack,
        white: normalBrWhite,
        fullWhite: normalBrFullWhite,
    },
    blackFriday: {
        black: blackFridayBrBlack,
        white: blackFridayBrWhite,
    },
    festaJunina: {
        black: festaJuninaBrBlack,
        white: festaJuninaBrWhite,
    },
    anoNovo: {
        black: reveillonBrBlack,
        white: reveillonBrWhite,
    },
    pascoa: {
        black: pascoaBrBlack,
        white: pascoaBrWhite,
    },
    diaDosNamorados: {
        black: diaDosNamoradosBrBlack,
        white: diaDosNamoradosBrWhite,
    },
    natal: {
        black: natalBrBlack,
        white: natalBrWhite,
    },
    carnaval: {
        black: carnavalBrBlack,
        white: carnavalBrWhite,
    },
    diaDasMaes: {
        black: diaDasMaesBrBlack,
        white: diaDasMaesBrWhite,
    },
    diaDosPais: {
        black: diaDosPaisBrBlack,
        white: diaDosPaisBrWhite,
    },
    copa: {
        black: copaBlack,
        white: copaWhite,
    },
};

export const logosOptionsEnum = {
    NORMAL: "normal",
    BLACK_FRIDAY: "blackFriday",
    FESTA_JUNINA: "festaJunina",
    ANO_NOVO: "anoNovo",
    PASCOA: "pascoa",
    DIA_DOS_NAMORADOS: "diaDosNamorados",
    NATAL: "natal",
    CARNAVAL: "carnaval",
    DIA_DAS_MAES: "diaDasMaes",
    DIA_DOS_PAIS: "diaDosPais",
    COPA: "copa"
}

const getFestiveLogo = () => {
    const themeName = window.BRCOM_THEME
    
    if (themeName && logosOptionsEnum[themeName]) {
        return logosOptionsEnum[themeName];
    }

    return logosOptionsEnum.NORMAL;
};

export const festiveLogo = getFestiveLogo();